import { EmptyCard } from '@frontend/web-icons';
import { Text, XStack, YStack } from '@frontend/web-react';

export const EmptyReviewTasks = () => (
  <YStack className="gap-lg px-md items-center">
    <XStack className="gap-sm">
      {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
      <YStack className="h-[70px] w-[148px]">
        <EmptyCard />
      </YStack>
      {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
      <YStack className="h-[70px] w-[148px]">
        <EmptyCard />
      </YStack>
      {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
      <YStack className="h-[70px] w-[148px]">
        <EmptyCard />
      </YStack>
    </XStack>
    <YStack className="gap-sm">
      <Text textAlign="center" type="h5">
        You’re all caught up! You may still have tasks in progress.
      </Text>
      <Text color="tertiary" textAlign="center" type="p-sm">
        See below to find out how best to duck it.
      </Text>
    </YStack>
  </YStack>
);
